module.exports = __webpack_public_path__ + "img/17cff3c163ad7c6e6dcb4ef9cd9ff9bf.png";